module.exports = __webpack_public_path__ + "img/horizontal_4@2x.1730e081.png";